import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class GroupsService {

  constructor(private http: HttpClient) { }
  ReadGroups(param): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/group/read/all`, param);
  }

  UpdateDeviceGroup(param): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/group/update/devices`, param);
  }

  AddDeviceGroup(param): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/group/add`, param);
  }

  DeleteDeviceGroup(param): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/group/delete`, param);
  }

  ReadSingleGroup(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/group/read/single`, params);
  }

  UpdateGroup(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/group/update/Details`, params);
  }

  ReadGroupShareInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/group/share/read`, params);
  }

  AddGroupShareInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/group/share/add`, params);
  }

  UpdateGroupShareInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/group/share/update`, params);
  }

  DeleteGroupShareInfo(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/group/share/delete`, params);
  }
}
